import { useState, useEffect } from 'react';
import { getCalendarEvents } from '../../lib/api';
import { Badge } from '../ui/badge';
import { format, parseISO, endOfMonth, addMonths } from 'date-fns';
import { DollarSign, ChevronRight } from 'lucide-react';

export const UpcomingPaymentsWidget = ({ onViewCalendar }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPaymentEvents = async () => {
      try {
        const start = new Date();
        const end = endOfMonth(addMonths(start, 1));
        const res = await getCalendarEvents(start.toISOString(), end.toISOString());
        const paymentEvents = res.data.filter(e => e.event_type === 'payment_due');
        setEvents(paymentEvents.slice(0, 3));
      } catch (err) {
        console.error('Failed to fetch payment events', err);
      } finally {
        setLoading(false);
      }
    };
    fetchPaymentEvents();
  }, []);

  if (loading || events.length === 0) return null;

  return (
    <button 
      onClick={onViewCalendar}
      className="flex items-center gap-3 px-3 py-1.5 rounded-lg bg-green-500/10 hover:bg-green-500/20 border border-green-500/20 transition-colors"
      data-testid="upcoming-payments-widget"
    >
      <div className="flex items-center gap-2">
        <DollarSign className="w-4 h-4 text-green-400" />
        <span className="text-sm font-medium text-green-400">Upcoming Payments</span>
        <Badge variant="secondary" className="bg-green-500/20 text-green-400 text-xs">
          {events.length}
        </Badge>
      </div>
      <div className="hidden lg:flex items-center gap-2 text-xs text-muted-foreground">
        {events.slice(0, 2).map((event, i) => (
          <span key={event.id || i} className="truncate max-w-[120px]">
            {event.title.split(' ').slice(0, 2).join(' ')}
            {i < Math.min(events.length, 2) - 1 && ','}
          </span>
        ))}
        {events.length > 2 && <span>+{events.length - 2} more</span>}
      </div>
      <ChevronRight className="w-4 h-4 text-green-400" />
    </button>
  );
};

export default UpcomingPaymentsWidget;
